import { render } from "./SectionCTA.vue?vue&type=template&id=3fb6be4c&scoped=true"
import script from "./SectionCTA.vue?vue&type=script&lang=js"
export * from "./SectionCTA.vue?vue&type=script&lang=js"

import "./SectionCTA.vue?vue&type=style&index=0&id=3fb6be4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb6be4c"]])

export default __exports__